import { FormattedMessage } from "react-intl";
import LoginTemplate from "components/templates/LoginTemplate";
import LoginWrapper from "components/layout/LoginWrapper";
import Typography from "components/common/Typography";
import VenueContextSelect from "components/data/VenueSelect/VenueContextSelect";
import { Button, Form } from "antd";
import { formItemLayout } from "const/formItemLayout";
import { ROUTE_PATHS } from "const/paths";
import { Link } from "react-router-dom";
import { useVenueContext } from "contexts/VenueContext";

import * as Styled from "./styles";

const VenueLogin: React.FC = () => {
  const { venue } = useVenueContext();

  return (
    <LoginTemplate>
      <Typography.Paragraph size="l" align="center">
        <FormattedMessage defaultMessage="Select your Venue" />
      </Typography.Paragraph>
      <LoginWrapper>
        <Form.Item {...formItemLayout}>
          <Styled.VenueLoginSelectWrapper>
            <VenueContextSelect />
          </Styled.VenueLoginSelectWrapper>
        </Form.Item>
        <Form.Item {...formItemLayout}>
          <Link to={ROUTE_PATHS.Dashboard}>
            <Button
              htmlType="submit"
              type="primary"
              size="large"
              block
              disabled={!venue}
            >
              <FormattedMessage defaultMessage="Continue" />
            </Button>
          </Link>
        </Form.Item>
      </LoginWrapper>
    </LoginTemplate>
  );
};

export default VenueLogin;
